import type { ReactNode } from "react";
import { Drawer } from "./Drawer";

interface RadioDrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export function RadioDrawer({ open, onClose, children }: RadioDrawerProps) {
  return (
    <Drawer open={open} onClose={onClose} title="Radio" closeLabel="Close radio panel" className="radio-drawer">
      {children}
    </Drawer>
  );
}
